"use client";

import Link from "next/link";
import { useActionState } from "react";
import { signInAction, signUpAction, type AuthState } from "../auth-actions";

const field =
  "mt-1 w-full rounded-lg border border-line bg-surface px-3 py-2.5 outline-none focus:border-accent";

export function SignInForm({
  signup,
  firstRun,
  next,
}: {
  signup: boolean;
  firstRun: boolean;
  next: string | null;
}) {
  const [state, action, pending] = useActionState<AuthState, FormData>(
    signup ? signUpAction : signInAction,
    {},
  );

  return (
    <>
      <form action={action} className="space-y-4">
        {/* Where to land afterwards, e.g. the trade planner they were sent from. */}
        {next && <input type="hidden" name="next" value={next} />}
        <label className="block text-sm font-medium">
          Email
          <input
            name="email"
            type="email"
            required
            autoComplete="email"
            autoCapitalize="none"
            spellCheck={false}
            className={field}
          />
        </label>

        <label className="block text-sm font-medium">
          Password
          <input
            name="password"
            type="password"
            required
            minLength={signup ? 10 : undefined}
            autoComplete={signup ? "new-password" : "current-password"}
            className={field}
          />
          {signup && (
            <span className="mt-1 block text-xs font-normal text-muted">
              At least 10 characters. Length matters more than symbols.
            </span>
          )}
        </label>

        {state.error && (
          <p className="rounded-lg border border-warn/30 bg-warn-soft px-3 py-2 text-sm text-warn">
            {state.error}
          </p>
        )}

        <button
          type="submit"
          disabled={pending}
          className="w-full rounded-lg bg-accent px-4 py-3 font-semibold text-on-accent hover:bg-accent-strong disabled:opacity-60"
        >
          {pending ? "Working…" : signup ? "Create account" : "Sign in"}
        </button>
      </form>

      {!firstRun && (
        <p className="mt-4 text-center text-sm text-muted">
          {signup ? (
            <>
              Already have an account?{" "}
              <Link href="/signin" className="font-medium text-accent hover:underline">
                Sign in
              </Link>
            </>
          ) : (
            <>
              Need an account?{" "}
              <Link
                href="/signin?mode=signup"
                className="font-medium text-accent hover:underline"
              >
                Create one
              </Link>
            </>
          )}
        </p>
      )}
    </>
  );
}
